import { fetchPost } from '../Service/ApiService'

export const bulkSendWelcomeBonusWithdraw = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`welcomebonuswithdrawrequest/bulksend`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};


export const bulkRejectWelcomeBonusWithdraw = (selectedIds, resolve, reject) => {   

    try {
        fetchPost(`welcomebonuswithdrawrequest/bulkreject`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};





